<template>
  <div class="WidgetsListView">
    <PageHeader title="Widgety"
                :description-in-modal="true"
                @openDescriptionModal="hintModalVisible = !hintModalVisible"
    />
    <ShPageLayout>
      <WidgetList />
      <ShDividerLine background-color="#2F323B" />
      <DomainsList v-if="$store.getters['authorization/acl'].hasPermission('restricted_domain_access')" />
    </ShPageLayout>
    <ShSideBarModal :title="`Zainstaluj widget: ${exampleWidget.name}`"
                    size="750px"
                    :side-bar-modal-visibility.sync="isModalWithCodeExampleVisible"
    >
      <WidgetCode slot="content"
                  :widget="exampleWidget"
                  @closeModal="isModalWithCodeExampleVisible = false"
      />
    </ShSideBarModal>
    <ShModalWindow v-if="hintModalVisible"
                   @closeModal="hintModalVisible = !hintModalVisible"
    >
      <template #header>
        <img style="margin-right:10px"
             :src="require('@/assets/images/ikona-widget.png')"
        >
        Widgety
      </template>
      <template #description>
        <PopupHints hint-template-name="widgets" />
      </template>
    </ShModalWindow>
  </div>
</template>

<script>
import { PopupHintsUtils } from '@/mixins';
import ShPageLayout from '@/components/Helpers/ShPageLayout';
import ShSideBarModal from '@/components/Helpers/ShSideBarModal';
import ShDividerLine from '@/components/Helpers/ShDividerLine';
import ShModalWindow from '@/components/Helpers/ShModalWindow';
import PageHeader from '@/components/Common/PageHeader';
import PopupHints from '@/components/Common/PopupHints';
import WidgetList from '@/components/Widgets/WidgetsList';
import WidgetCode from '@/components/Widgets/WidgetCode';
import DomainsList from '@/components/Domains/DomainsList';

export default {
  name: 'WidgetsListView',
  components: {
    PageHeader,
    ShPageLayout,
    ShSideBarModal,
    ShDividerLine,
    ShModalWindow,
    PopupHints,
    WidgetList,
    WidgetCode,
    DomainsList,
  },

  mixins: [PopupHintsUtils],

  data() {
    return {
      exampleWidget: {},
      isModalWithCodeExampleVisible: false,
    };
  },

  created() {
    this.mCheckInLocalStorageIfModalHasBeenAlreadyShown('widgetModalOpen');
    this.$EventBus.$on('WidgetsListItem/SHOW_CODE_EXAMPLE', (widget) => {
      this.handleShowWidgetCodeExample(widget);
    });
  },

  beforeDestroy() {
    this.$EventBus.$off('WidgetsListItem/SHOW_CODE_EXAMPLE');
  },

  methods: {
    handleShowWidgetCodeExample(widget) {
      this.isModalWithCodeExampleVisible = true;
      this.exampleWidget = widget;
    },
  },
};
</script>
